import React from "react";
import Alert from "@mui/material/Alert";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import GetAppIcon from "@mui/icons-material/GetApp";
import TableChartIcon from "@mui/icons-material/TableChart";

// Componente de Upload de Arquivo
function FileUploadStep({ logic }) {
  return (
    <div className="enhanced-import-step file-upload-step">
      <div className="file-upload-container">
        <div className="file-upload-area">
          <CloudUploadIcon className="file-upload-icon" />

          <div className="file-upload-info">
            <h3>Selecione um arquivo para importar</h3>
            <p>Formatos aceites: Excel (.xls, .xlsx)</p>
            <p className="file-upload-limit">Tamanho máximo: 1MB</p>
          </div>

          <input
            type="file"
            id="file-upload-input"
            onChange={logic.handleFileChange}
            accept=".xls,.xlsx,.csv"
            className="file-upload-input"
          />

          <label htmlFor="file-upload-input" className="file-upload-button">
            Selecionar Arquivo
          </label>

          {logic.file && (
            <div className="file-upload-selected">
              <CheckCircleIcon className="file-upload-selected-icon" />
              <span>Arquivo selecionado: {logic.file.name}</span>
            </div>
          )}
        </div>

        {logic.errorMessage && (
          <Alert severity="error" className="file-upload-error">
            {logic.errorMessage}
          </Alert>
        )}

        {/* <div className="file-upload-template">
          <h4>Não tem um arquivo pronto?</h4>
          <p>Baixe nosso modelo de Excel para importação:</p>
          <a
            href="/modeloImportStock.xlsx"
            download="modeloImportStock.xlsx"
            className="file-upload-template-link"
          >
            <GetAppIcon className="file-upload-template-icon" />
            Baixar Modelo de Importação
          </a>
        </div> */}

        <div className="file-upload-help">
          <div className="file-upload-help-header">
            <TableChartIcon className="file-upload-help-icon" />
            <h4>Instruções de importação:</h4>
          </div>

          <p>Seu arquivo deve conter as seguintes colunas:</p>

          <table className="file-upload-template-table">
            <thead>
              <tr>
                <th>Campo</th>
                <th>Descrição</th>
                <th>Obrigatório</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="file-upload-template-required">Nome</td>
                <td>Nome completo do produto</td>
                <td>Sim</td>
              </tr>
              <tr>
                <td className="file-upload-template-required">Quantidade</td>
                <td>Quantidade a adicionar</td>
                <td>Sim</td>
              </tr>
              <tr>
                <td>Lote</td>
                <td>Código do lote (valor padrão: "N/A")</td>
                <td>Não</td>
              </tr>
              <tr>
                <td>Data de Validade</td>
                <td>Data de validade no formato DD/MM/YYYY</td>
                <td>Não</td>
              </tr>
              <tr>
                <td>Stock mínimo</td>
                <td>Quantidade mínima desejada no estoque</td>
                <td>Não</td>
              </tr>
              <tr>
                <td>Unidade de Medida</td>
                <td>UN (unidade), KG (kg), L (litro), etc.</td>
                <td>Não</td>
              </tr>
              <tr>
                <td>Preço de Compra</td>
                <td>Valor unitário do produto</td>
                <td>Não</td>
              </tr>
              <tr>
                <td>Classificação</td>
                <td>Matéria Prima ou Produto Acabado</td>
                <td>Não</td>
              </tr>
              <tr>
                <td>Armazém</td>
                <td>Localização física principal (padrão: A1)</td>
                <td>Não</td>
              </tr>
              <tr>
                <td>Localização</td>
                <td>Localização física específica (padrão: A1)</td>
                <td>Não</td>
              </tr>
            </tbody>
          </table>

          <div className="file-upload-tips">
            <h5>Dicas importantes:</h5>
            <ul>
              <li>
                O sistema tentará reconhecer automaticamente produtos existentes
                pelo nome.
              </li>
              <li>
                Os nomes de colunas não precisam ser exatos, o sistema tentará
                reconhecê-los.
              </li>
              <li>
                Para armazém e localização, recomendamos o formato Letra+Número
                (ex: A1, B2)
              </li>
              <li>
                Classificação: use "Matéria Prima" ou "Produto Acabado" (padrão:
                Produto Acabado)
              </li>
              <li>
                O fornecedor deve ser selecionado na etapa de revisão dos dados.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FileUploadStep;
